import { render, staticRenderFns } from "./bsp-dialog.vue?vue&type=template&id=2e2b82f6&scoped=true&"
import script from "./bsp-dialog.vue?vue&type=script&lang=js&"
export * from "./bsp-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b82f6",
  null
  
)

export default component.exports